import React, { ReactNode } from 'react';
import { Spinner } from '../../atoms';
import { ErrorText, LoadingContainer } from './styles';

export interface LoadableViewProps {
  loading: boolean;
  error?: string;
  children?: ReactNode; // ✅ Add children here
}

export const LoadableView: React.FC<LoadableViewProps> = ({
  loading,
  error,
  children,
}) => {
  if (loading)
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );
  if (error) return <ErrorText>{error}</ErrorText>;
  return <>{children}</>;
};
